if ( $('.media--dropdown').length > 0 ) {

  var grid = $('.media--grid');
  var $selects = $('.media--dropdown');

  var filterKeysById = {
    'media-filter--year': 'year',
    'media-filter--category': 'cat',
  };

  function normalizeYearParam(raw) {
    var y = parseInt(raw, 10);
    if (isNaN(y) || y < 1970 || y > 2100) return '';
    return String(y);
  }

  function syncUrlFromState() {
    var url = new URL(window.location.href);
    $selects.each(function () {
      var key = filterKeysById[this.id];
      if (!key) return;
      var value = $(this).val() || '';
      if (key === 'year') value = normalizeYearParam(value);
      if (value) url.searchParams.set(key, value);
      else url.searchParams.delete(key);
    });
    history.replaceState(null, '', url.toString());
  }

  function syncStateFromUrl() {
    var url = new URL(window.location.href);
    $selects.each(function () {
      var key = filterKeysById[this.id];
      if (!key) return;
      var value = url.searchParams.get(key) || '';
      if (key === 'year') value = normalizeYearParam(value);
      $(this).val(value);
    });
  }

  syncStateFromUrl();

  $(".posts--pagination-more").on('click',function(e) {
    e.preventDefault();
    var paged = parseFloat( $(this).attr('data-next') );
    var type  = $(this).attr('data-type');
    type = type ? type : 'post'
    updateMediaResults(paged, type);
  });

  $(".media--dropdown").on('change',function() {
    syncUrlFromState();
    updateMediaResults();
  });

  window.addEventListener('popstate', function () {
    syncStateFromUrl();
    updateMediaResults(1);
  });

  var updateMediaResults = function( paged, type ) {

    paged       = paged ? paged : 1;
    let filters = $('.media--filters');

    $.ajax({
       type     : "post",
       dataType : "json",
       url      : localized_object.ajax_url,
       data : {
          action : "get_media_form",
          year   : $('#media-filter--year').val(),
          cat   : $('#media-filter--category').val(),
          nonce  : localized_object.nonce,
          paged  : paged
       },
       timeout    : 300000,
       beforeSend : function() {
          filters.addClass('is-loading');
          filters.css({'cursor': 'wait'});
          filters.find('input, button, select, label').css({'cursor': 'wait'});
       }
    }).done( function( response ) {



      if ( response && typeof response.media !== 'undefined' ) {

        var count = $('.cur-num').text();
        var html = response.media;

        if ( !html || !String(html).trim() ) {
          html = '<p class="media--empty">No press releases match your filters. Try a different year or category.</p>';
        }

        grid.html(html);

        $(".posts--pagination-more").attr('data-next', response.cur_page + 1 );
        $('.cur-num').html(count);
        $('.max-num').html(parseFloat(response.max_count));

        if ( response.max_pages && response.cur_page < response.max_pages ) {
          $(".posts--pagination-more").show();
        } else {
          $(".posts--pagination-more").hide();
        }

      }

    }).fail( function( request, status, err ) {

       console.log( 'REQUEST => ' + request );
       console.log( 'STATUS => ' + status );
       console.log( 'ERR => ' );
       console.log( err );

    }).always(function() {

      filters.removeClass('is-loading');
      filters.css({'cursor': 'auto'});
      filters.find('input, button, select, label').css({'cursor': 'auto'});

    });

  }

}

